import { useState, useEffect } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import useAxios from "../../services/useAxios.tsx";
import Cards from "../kits/card/Cards.jsx";
import ColorSchema from "../kits/Color";
import { HomeIcon } from "../kits/Icons.tsx";
// images
import bgBlue from "../../assets/images/blui.svg";
import bgPurple from "../../assets/images/purpl.svg";
import bgPink from "../../assets/images/pink.svg";
import icon1 from "../../assets/images/inventory-icon1.png";
import icon2 from "../../assets/images/inventory-icon2.png";
import icon3 from "../../assets/images/inventory-icon.png";
import icon from "../../assets/images/inventory-icon3.png";

import Loader from "../../utils/Loader.jsx";

export default function StorageCard() {
  const { execute: inventoryInfo } = useAxios("api2/inventory_info");
  const [inventory, setInventory] = useState({});

  useEffect(() => {
    inventoryInfo().then(data => {
      setInventory(data);
    });
  }, []);
  return (
    <>
      <div className="d-flex flex-wrap justify-content-center ">
        <div>
          <Cards
            // img={bgPurple}
            color="#4242a9"
            title="تعداد کل کالاهای موجود در انبار"
            Icon={icon}
            number={addCommas(inventory.total)}
            iconType="img"
          ></Cards>
        </div>
        <div>
          <Cards
            // img={bgBlue}
            color="#f95454"
            title="تعداد کل کالاها با موجودی صفر"
            Icon={icon3}
            number={addCommas(inventory.empty)}
            iconType="img"
          ></Cards>
        </div>
        <div>
          <Cards
            // img={bgPink}
            color="#974f97"
            title="تعداد کل اقلام موجود در انبار"
            Icon={icon1}
            number={addCommas(inventory.inventory)}
            iconType="img"
          ></Cards>
        </div>
      </div>
    </>
  );
}
